import { supabase } from './supabase';
import { extractFunctionErrorMessage } from '../utils/supabaseFunctionError';

// ADMIN > Encargados: listar encargados existentes y gestionar los
// productores que cada uno tiene autorizados. No hay policy RLS que
// permita a ADMIN leer/escribir esto libremente desde el cliente, así que
// vive en su propia Edge Function + RPCs (admin-encargados -> admin_*),
// mismo patrón que adminSolicitudes.js / adminFertilizantes.js.

const FUNCTION_NAME = 'admin-encargados';
const GENERIC_ERROR = 'No se pudo completar la operación. Intenta nuevamente.';

async function invoke(body) {
  const { data, error } = await supabase.functions.invoke(FUNCTION_NAME, { body });
  if (error) {
    const message = await extractFunctionErrorMessage(error);
    return { ok: false, message: message || GENERIC_ERROR };
  }
  return { ok: true, data };
}

export async function listarEncargadosAdmin() {
  const result = await invoke({ accion: 'LISTAR' });
  if (!result.ok) return result;
  return { ok: true, encargados: result.data?.encargados ?? [] };
}

export async function obtenerProductoresEncargadoAdmin(idencargado) {
  const result = await invoke({ accion: 'OBTENER_PRODUCTORES', idencargado: Number(idencargado) });
  if (!result.ok) return result;
  return { ok: true, encargado: result.data?.encargado ?? null };
}

export async function guardarProductoresEncargadoAdmin(idencargado, productoresIds) {
  return invoke({
    accion: 'GUARDAR_PRODUCTORES',
    idencargado: Number(idencargado),
    productores_ids: (productoresIds ?? []).map((id) => Number(id)),
  });
}
